
<template>
    <div id="content_public">

        <div class="mt-3 row justify-content-center">
            <select v-model="selectedFunction">
                <option v-for="func in functions" :value="func.value" v-bind:key="func.text">{{ func.text }}</option>
            </select>
        </div>

        <div class="mt-3 row justify-content-center">
            <input v-model.lazy="search" placeholder="search">
            <button v-on:click="runSelectedFunction()">search</button>
        </div>

        <div v-if="selectedFunction == 'getConcussionFeature'" class="mt-3 row justify-content-center">
            <select v-model="selectedMotionDataId">
                <option v-for="item in model" :value="item.MotionDataId" v-bind:key="item.MotionDataId">
                    {{
                        item.CourseType + " : " + formatDatetime(item.StartingTime)
                    }}
                </option>
            </select>
            <select v-model="selectedType" disabled readonly>
                <option v-for="typeName in concussionType" :value="typeName.value" v-bind:key="typeName.text">
                    {{
                        typeName.text
                    }}
                </option>
            </select>
        </div>

        <div class="mt-3 row justify-content-center">
            <p class="text-danger">{{ errorMsg }}</p>
        </div>
        <div v-if="search != ''">
            <cmpChart v-bind:chart-type="'Table'" v-bind:rowData="this.userInfo">
            </cmpChart>
        </div>
        <div class="row justify-content-center">
            <template v-if="chartObj.length > 0">
                <div class="mb-5 col-11 col-xl-5" v-for="(item, index) in chartObj" :key="index">
                    <cmpChart v-bind:chart-type="item.chartType" v-bind:chartData="item.chartData"
                        v-bind:chart-options="item.chartOptions">
                    </cmpChart>
                </div>
            </template>
            <div class="mb-5 col-11 col-xl-5" v-if="aiScore != -1">
                <cmpAIScore v-bind:score="aiScore" v-bind:title="'Concussion AI Score'"
                    v-bind:text="'This is the probability of having Concussion'"></cmpAIScore>
            </div>
        </div>
        <div class="row justify-content-center">
            <template v-if="pictureObj.length > 0">
                <div class="mb-5 col-11 col-xl-5" v-for="(item, index) in pictureObj" :key="index">
                    <cmpChart v-bind:chart-type="'ImageUrl'" v-bind:image-src="item.src"
                        v-bind:feature-name="Object.keys(pictureEx)[index]">
                    </cmpChart>
                </div>
            </template>
        </div>
        <div v-if="modelTablesCol.length > 0">
            <cmpChart v-bind:chart-type="'Table'" v-bind:rowData="this.modelTablesRow"
                v-bind:columnDefs="this.modelTablesCol">
            </cmpChart>
        </div>
        <br>
    </div>
</template>


<script>
import CmpAIScore from '../components/common/cmpAIScore.vue';
import cmpChart from '../components/common/cmpChart.vue';
import ApiService from '@/ApiService';
import { gmtToLocal } from '@/util/dateutil';


export default {
    components: {
        cmpChart,
        CmpAIScore
    },
    watch: {
        selectedMotionDataId: {
            handler: function (newValue) {
                if (this.selectedFunction == 'getConcussionFeature') {
                    this.selectedType = this.concussionType.find(obj => obj.text === this.model.find(item => item.MotionDataId == this.selectedMotionDataId).CourseType).value;
                    this.createConcussionFeature();
                }
                else {
                    this.createConcussionFeatureHistory();
                }
            },
        },
        selectedFunction: {
            handler: function (newValue) {
                this.runSelectedFunction();
            },
        },
        selectedType: {
            handler: function (newValue) {
                if (this.selectedFunction == 'getConcussionFeature') {
                    this.createConcussionFeature();
                }
                else {
                    this.createConcussionFeatureHistory();
                }
            },
        }
    },
    data() {
        return {
            selectedMotionDataId: -1,
            selectedFunction: 'getConcussionFeature',
            selectedType: 'FX_',
            functions: [
                { text: 'Concussion', value: 'getConcussionFeature' },
                { text: 'Concussion History', value: 'getConcussionFeatureHistory' }
            ],
            concussionType: [
                { text: 'Concussion', value: 'FX_' },
            ],
            errorMsg: "",
            aiScore: -1,//-1是代表初始值，正常情況不會小於0，現階段相同的activityid aiScore都一樣
            search: "",
            model: {},
            features: {},
            valuePRs: {},
            goldenSamples: {},//紀錄平均值
            chartObj: [],
            pictureObj: [],
            pictureEx: [],
            pictureBlob: [],
            dateList: [],
            brainPictureCondition1: 0,
            brainPictureCondition2: 0,
            brainScore: 0,
            userInfo: [],
            modelTablesCol: [],
            modelTablesRow: [],
            chartColor: ['rgba(244, 67, 54,0.7)', 'rgba(255, 160, 0,0.7)', 'rgba(205, 220, 57,0.7)', 'rgba(0, 150, 136,0.7)', 'rgba(3, 169, 244,0.7)', 'rgba(63, 81, 181,0.7)', 'rgba(103, 58, 183,0.7)', 'rgba(96, 125, 139,0.7)'],
            groupLabels: ['Concussion_Feature'],
            featureLabels: [['Eye_Tracking_Dist','Eye_Game_Time','Eye_Tracking_Speed','Eye_X_Average','Eye_Reaction_Time_Max','Eye_Reaction_Time_Std']],
            pictureLabels: [['SSVEP_EEG_PIC'], ['FX_EYE_PIC'], ['CAS_EYE_PIC']],
            brainPicture: [
                [`${process.env.VUE_APP_S3PUBLIC}/vrca/00.jpg`, `${process.env.VUE_APP_S3PUBLIC}/vrca/01.jpg`],
                [`${process.env.VUE_APP_S3PUBLIC}/vrca/10.jpg`, `${process.env.VUE_APP_S3PUBLIC}/vrca/11.jpg`]
            ]

        };
    },
    methods:
    {
        initData() {
            this.aiScore = -1;
            this.errorMsg = "";
            this.chartObj = [];
            this.features = {};
            this.valuePRs = {};
            this.pictureObj = [];
            this.modelTablesRow = [];
            this.modelTablesCol = [];
        },
        runSelectedFunction() {
            this.getMemberInfo(this.search);
            this[this.selectedFunction]();
        },
        formatDatetime(d) {
            const localDate = gmtToLocal(d);
            if (localDate) {
                return localDate.replace('T', ' ');
            }

            return null;
        },
        async getConcussionFeature() {
            try {
                //呼叫api讀取資料
                //呼叫api讀取資料
                let api = new ApiService("Motiondata");
                const requestData =
                {
                    MemberId: this.search,
                    CourseName: "Concussion",
                    CourseType:"Concussion"
                }
                this.model = await api.getAll(requestData, 'feature_value/member_id');
                this.model = this.model.filter(item => {
                    return this.concussionType.some(concussionItem => concussionItem.text === item.CourseType);
                });
                this.selectedMotionDataId = this.model[0].MotionDataId;
                this.createConcussionFeature();
            } catch (error) {
                console.log(error);
                this.initData();
                this.errorMsg = "Can't find this data";
            }
        },
        async createConcussionFeature() {
            try {
                this.initData();
                let motiondata = this.model.find(item => item.MotionDataId == this.selectedMotionDataId);
                if (motiondata.ModelOutput == null) {
                    this.aiScore = -1;

                }
                else{
                    await this.modelProcess(motiondata.ModelOutput.ModelOutput);
                    if ( "ADHDAC_Possibility" in motiondata.ModelOutput.ModelOutput) {
                        this.aiScore = parseInt(motiondata.ModelOutput.ModelOutput["ADHDAC_Possibility"]);
                    }
                } 
                let api = new ApiService("GoldenSampleFeature");
                this.goldenSamples = await api.getAll({ CouredId: motiondata.CouredId });
                //處理成可以用featureName當作key值呼叫的格式
                this.goldenSamples = this.goldenSamples.Data.reduce((acc, { FeatureFieldName, FeatureValue, FeatureFieldValueAbnormal, FeatureFieldValueNormal, FeatureFieldSorting }) => {
                    acc[FeatureFieldName] = { FeatureValue, FeatureFieldValueAbnormal, FeatureFieldValueNormal, FeatureFieldSorting };
                    return acc;
                }, {});
                this.valuePRs = motiondata.FeatureValue.FeatureName.reduce((obj, key, index) => {
                    obj[key] = motiondata.FeatureValue.FeaturePR[index];
                    return obj;
                }, {});
                this.features = motiondata.FeatureValue.FeatureName.reduce((obj, key, index) => {
                    obj[key] = motiondata.FeatureValue.FeatureValue[index];
                    return obj;
                }, {});
                this.pictureBlob = motiondata.FeatureValue.FeatureBlobName.reduce((obj, key, index) => {
                    obj[key] = motiondata.FeatureValue.FeatureBlob[index];
                    return obj;
                }, {});
                this.pictureLabels.forEach((labels, index) => {
                        const label = labels[0];
                        const url = motiondata.FeatureValue.FeatureEx[motiondata.FeatureValue.FeatureExName.indexOf(label)];
                        this.pictureEx[label] = url;
                    });
                //生成adhd ChartObj的資料，一組最多6個(版面及配色原因)
                //const chartType = 'Radar';//雷讀圖選項
                const chartType = 'Bar';
                const backgroundColor = this.chartColor[0];
                const label = 'Case';
                const averageLabel = 'Average';
                const averageBackgroundColor = this.chartColor[1];

                //生成chartData
                const chartData = await this.featureLabels.map((labelsArray) => {
                    return {
                        labels: labelsArray.map(label => {
                            return [this?.valuePRs[this.selectedType + label] ? "PR : " + this.valuePRs[this.selectedType + label] : "PR : Not calculated", label];
                        }),
                        datasets: [
                            {
                                data: labelsArray.map(label => {
                                    //如果腦電特徵沒資料時根據正常人平均生出假資料
                                    if (['Pz_delta', 'Pz_theta', 'Pz_alpha', 'Pz_beta', 'Pz_gamma', 'FCz_delta', 'FCz_theta', 'FCz_alpha', 'FCz_beta', 'FCz_gamma',
                                        'FC3_delta', 'FC3_theta', 'FC3_alpha', 'FC3_beta', 'FC3_gamma', 'Oz_delta', 'Oz_theta', 'Oz_alpha', 'Oz_beta', 'Oz_gamma'].includes(label)) {
                                        return this?.features[this.selectedType + label] ? this.features[this.selectedType + label] : this.goldenSamples[this.selectedType + label]?.FeatureFieldValueNormal * 1.05;
                                    }
                                    else {
                                        return this?.features[this.selectedType + label] ? this.features[this.selectedType + label] : 0;
                                    }
                                })
                            },
                            {
                                data: labelsArray.map(label => {
                                    return this.goldenSamples[this.selectedType + label]?.FeatureFieldValueNormal ? this.goldenSamples[this.selectedType + label].FeatureFieldValueNormal : 0;
                                })
                            }
                        ],

                    };
                });
                await this.compare(chartData);
                this.createPicture();

                //生成ChartObj的完整格式
                this.chartObj = chartData.map((data, i) => ({
                    chartType,
                    chartData: {
                        labels: data.labels,
                        datasets: [
                            {
                                label,
                                backgroundColor,//更改背景顏色
                                // backgroundColor: 'rgba(244, 67, 54,0.3)', //雷達圖選項
                                // borderColor:backgroundColor,
                                data: data.datasets[0].data
                            },
                            {
                                label: averageLabel,
                                backgroundColor: averageBackgroundColor,
                                // backgroundColor: 'rgba(255, 160, 0,0.3)',//雷達圖選項
                                // borderColor:averageBackgroundColor,
                                data: data.datasets[1].data
                            }
                        ]
                    },
                    chartOptions: {
                        plugins: {
                            //此title是每組圖表的
                            title: {
                                display: true,
                                text: this.groupLabels[i]
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        //indexAxis: 'y', //是否水平顯示
                        scales: {//如要顯示雷達圖需註解scales{}
                            x: {
                                ticks: {
                                    // 把過長的字元簡化
                                    callback: function (value, index, ticks) {
                                        var characterLimit = 10;
                                        var lable = Object.assign([], this.getLabelForValue(value));
                                        if (lable[1].length >= characterLimit && ticks.length > 3) {
                                            lable[1] = lable[1].slice(0, lable[1].length).substring(0, characterLimit - 1).trim() + '...';
                                            return lable;
                                        }
                                        return lable;
                                    }
                                }
                            }
                        }
                    }
                }));
            } catch (error) {
                console.log(error);
                this.initData();
                this.errorMsg = "Can't find this data";
            }
        },
        async createPicture() {
            try {
                const pictureData = await this.pictureLabels.map((labelsArray) => {
                    return {
                        datasets: [
                            {
                                data: labelsArray.map(label => {
                                    return this?.pictureEx[label] ? this.pictureEx[label] : 0;
                                }),
                            }
                        ],

                    };
                });
                this.pictureObj = pictureData.map((data, i) => ({
                    src: data.datasets[0].data[0]
                }));
                this.pictureObj.push({
                    src: this.brainPicture[this.brainPictureCondition1][this.brainPictureCondition2]
                });
            } catch (error) {
                console.log(error);
                this.initData();
                this.errorMsg = "Can't find this data";
            }
        },
        async getConcussionFeatureHistory() {
            try {
                //呼叫api讀取資料
                let api = new ApiService("Motiondata");
                const requestData =
                {
                    MemberId: this.search,
                    CourseName: "Concussion"
                }
                this.model = await api.getAll(requestData, 'feature_value/member_id');
                this.model = this.model.filter(item => {
                    return item.FeatureValue != null;
                });
                this.model.forEach((item) => {
                    item.FeatureValue = JSON.parse(item.FeatureValue);
                });

                this.createConcussionFeatureHistory();

            } catch (error) {
                console.log(error);
                this.initData();
                this.errorMsg = "Can't find this data";

            }

        },
        createConcussionFeatureHistory() {
            try {
                this.initData();
                //處理資料格式
                this.dateList = [];
                this.model.forEach((item) => {
                    if (item.CourseType == this.concussionType.find(option => option.value == this.selectedType).text) {
                        this.dateList.push(item.StartingTime ? item.StartingTime : '2023/01/01');//data是null時2023/01/01為暫時預設
                        item.FeatureValue.FeatureName.forEach((feature, i) => {
                            if (!this.features[feature]) {
                                this.features[feature] = [item.FeatureValue.FeatureValue[i]];
                                //this.valuePRs[feature] = [item.featureValue.FeaturePR[i]];//歷次report部分暫時不需使用PR
                            } else {
                                this.features[feature].push(item.FeatureValue.FeatureValue[i]);
                                //this.valuePRs[feature].push(item.featureValue.FeaturePR[i]);//歷次report部分暫時不需使用PR
                            }
                        });
                    }

                });
                //生成歷次adhd ChartObj的資料
                const chartType = 'Line';

                //生成chartData
                const chartData = this.featureLabels.map(labels => {
                    return {
                        datasets: labels.map(label => {
                            return {
                                label,
                                data: this?.features[this.selectedType + label] ? this.features[this.selectedType + label] : 0
                            }
                        })
                    };
                });

                //設定chartData feature的顏色
                chartData.map(data => {
                    data.datasets.forEach((item, i) => {
                        item['borderColor'] = this.chartColor[i];
                        item['backgroundColor'] = this.chartColor[i];
                    })
                })
                //生成ChartObj的完整格式
                this.chartObj = chartData.map((data, i) => ({
                    chartType,
                    chartData: {
                        labels: this.dateList,
                        datasets: data.datasets
                    },
                    chartOptions: {
                        plugins: {
                            //此title是每組圖表的
                            title: {
                                display: true,
                                text: this.groupLabels[i]
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        //indexAxis: 'y', //是否水平顯示
                        scales: {
                            x: {
                                ticks: {
                                    //把時間格式縮減
                                    callback: function (value, index, ticks) {
                                        var characterLimit = 11;
                                        var lable = this.getLabelForValue(value);

                                        if (lable.length >= characterLimit && ticks.length > 0) {
                                            lable = lable.slice(0, lable.length).substring(0, characterLimit - 1).trim() + '...';
                                            return lable;
                                        }
                                        return lable;
                                    }
                                }
                            }
                        }
                    }
                }));

            } catch (error) {
                console.log(error);
                this.initData();
                this.errorMsg = "Can't find this data";

            }

        },
        //[ {"datasets": [ { "data": [ 0, 1, 2, 3, 4, 5, 6 ] }, { "data": [ 0, 0, 0, 0, 0, 0, 0 ] } ] } ] 左邊data是featurevalue值,右邊data是對應的平均值
        async compare(array1) {
            let count = 0;
            this.brainScore = this.features.SSVEP_SNR;
            this.brainPictureCondition1 = 0;
            this.brainPictureCondition2 = 0;
            for (let i = 0; i < array1[0].datasets[0].data.length; i++) {
                if (array1[0].datasets[0].data[i] > array1[0].datasets[1].data[i])
                    count++;
            }
            this.brainPictureCondition1 = count >= 4 ? 1 : 0;
            this.brainPictureCondition2 = this.brainScore <= 4.8 ? 1 : 0;
        },
        async getMemberInfo(memberID) {
            let api = new ApiService("User");
            let user = await api.getAll({ MemberId: memberID });
            this.userInfo = user.Data.map(item => {
                return {
                    name: item.Name,
                    birthday: item.Birthday,
                    gender: item.Gender
                };
            });
        },
        async modelProcess(model) {
            const keys = Object.keys(model);
            this.modelTablesCol =
                [
                    { headerName: 'ModelName', field: 'modelName', width: 350 },
                    { headerName: 'Result', field: 'result', cellStyle: this.getCellStyle, width: 260 },
                ];
            this.modelTablesRow = Object.keys(model).map(key => ({
                modelName: key,
                result: model[key],
            }));
        },
        getCellStyle(params) {
            if (params.value === "normal") {
                return { color: 'green' };
            } else {
                return { color: 'red' };
            }
        }


    }

}
</script>